import { HTTP_METHODS } from "@src/constants/http-methods.constant";
import { INTERNAL_API_ENDPOINTS } from "@src/constants/internal-api-endpoints-constants";
import { callApi, extractApiErrorMessage } from "@src/utils/api-client";

export type StartPortalRegistrationRequest = {
  user_uuid: string;
  appt_id: number;
  department_id: number;
};

type StartPortalRegistrationApiResponse = {
  authorizeUrl?: unknown;
  message?: unknown;
  registrationExpired?: unknown;
};

export type StartPortalRegistrationResult = {
  success: boolean;
  authorizeUrl?: string;
  message?: string;
  registrationExpired?: boolean;
};

export type SendPortalInvitationResult = {
  success: boolean;
  message?: string;
};

export const startPortalRegistration = async (
  request: StartPortalRegistrationRequest,
): Promise<StartPortalRegistrationResult> => {
  const { data, response } = await callApi({
    method: HTTP_METHODS.POST,
    endpoint: INTERNAL_API_ENDPOINTS.PORTAL_REGISTRATION_START,
    body: request,
  });
  const result = (data ?? {}) as StartPortalRegistrationApiResponse;

  if (!response.ok || typeof result.authorizeUrl !== "string" || !result.authorizeUrl) {
    return {
      success: false,
      message: extractApiErrorMessage(data, response),
      ...(result.registrationExpired === true ? { registrationExpired: true } : {}),
    };
  }

  return {
    success: true,
    authorizeUrl: result.authorizeUrl,
    message: undefined,
  };
};

export const sendPortalInvitation = async (
  request: StartPortalRegistrationRequest,
): Promise<SendPortalInvitationResult> => {
  const { data, response } = await callApi({
    method: HTTP_METHODS.POST,
    endpoint: INTERNAL_API_ENDPOINTS.PORTAL_REGISTRATION_INVITATION,
    body: request,
  });
  const result = (data ?? {}) as { success?: unknown };

  return {
    success: response.ok && result.success === true,
    message:
      response.ok && result.success === true ? undefined : extractApiErrorMessage(data, response),
  };
};
